import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BASE_URL_USER}/user/auth`;

export const getAuth = async (token) => {
  const response = await axios.get(baseUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (response.status !== 200) return "Unauthorized";
  return response.data;
};
